module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_21_4.a1c267d1.jpeg";